import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function Login() {
  const { login, sendResetEmail } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [resetMessage, setResetMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const userCredential = await login(email, password);
      // Get the Firebase ID token
      const token = await userCredential.user.getIdToken();
      localStorage.setItem('adminToken', token); // <-- Store the token
      setSuccess('Login successful! Redirecting...');
      setTimeout(() => navigate('/admin'), 1000);
    } catch (err) {
      setError(err.message || 'Invalid email or password');
    }
    setLoading(false);
  };

  // Real forgot password handler
  const handleForgot = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage('');
    setLoading(true);
    try {
      await sendResetEmail(email);
      setResetMessage('Check your email for a password reset link.');
    } catch (err) {
      setError(err.message || 'Failed to send reset email.');
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen q2o-bg">
      <form onSubmit={forgot ? handleForgot : handleSubmit} className="q2o-card border border-q2o-purple w-full max-w-md">
        <h2 className="text-3xl font-bold mb-6 text-center text-q2o-purple">{forgot ? 'Reset Password' : 'Login'}</h2>
        {error && <div className="mb-4 text-red-500 text-sm text-center">{error}</div>}
        {success && <div className="mb-4 text-green-500 text-sm text-center">{success}</div>}
        {resetMessage && <div className="mb-4 text-green-500 text-sm text-center">{resetMessage}</div>}
        {!forgot && <>
          <div className="mb-4">
            <label className="block mb-1 text-q2o-purple font-semibold">Email</label>
            <input
              type="email"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring bg-q2o-card text-white"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); setSuccess(''); }}
              required
            />
          </div>
          <div className="mb-4 relative">
            <label className="block mb-1 text-q2o-purple font-semibold">Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring bg-q2o-card text-white pr-10"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); setSuccess(''); }}
              required
            />
            <span
              className="absolute right-3 top-9 cursor-pointer text-q2o-purple"
              onClick={() => setShowPassword((v) => !v)}
              tabIndex={0}
              role="button"
              aria-label="Toggle password visibility"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <div className="flex justify-between items-center mb-6">
            <button type="button" className="text-q2o-purple hover:underline text-sm" onClick={() => { setForgot(true); setResetMessage(''); setError(''); }}>Forgot Password?</button>
          </div>
        </>}
        {forgot && (
          <div className="mb-4">
            <label className="block mb-1 text-q2o-purple font-semibold">Enter your email</label>
            <input
              type="email"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring bg-q2o-card text-white"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
        )}
        <button
          type="submit"
          className="w-full btn btn-primary btn-lg"
          disabled={loading}
        >
          {loading ? (forgot ? 'Sending Reset Link...' : 'Logging in...') : (forgot ? 'Send Reset Link' : 'Login')}
        </button>
        <div className="mt-4 text-center text-sm">
          {forgot ? (
            <button type="button" className="text-q2o-purple hover:underline" onClick={() => { setForgot(false); setResetMessage(''); setError(''); }}>Back to Login</button>
          ) : (
            <>Don&apos;t have an account? <a href="/register" className="text-q2o-purple hover:underline">Register</a></>
          )}
        </div>
      </form>
    </div>
  );
} 